import { Popover } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledContent = styled.div`
    p {
        margin-bottom: 0.5em;
    }

    img {
        display: block;
        max-width: 100%;
        margin: 0 auto;
    }
`;

/**
 * 气泡提示组件
 * @component
 * @example
 * // 基础用法
 * <PopoverTip content="这是一段提示文字">
 *     <Button>悬停查看提示</Button>
 * </PopoverTip>
 *
 * // 带图片的提示
 * <PopoverTip
 *     content={<>
 *         <p>图片说明文字</p>
 *         <img src="image.jpg" alt="提示图片"/>
 *     </>}
 * >
 *
 * // Form Label
 * label={<>
 *     <span>封面图</span>
 *     <PopoverTip
 *         placement="right"
 *         content={<>
 *             <p>展示位置：<a target="_blank" href="https://project.cn-healthcare.com/">医项目聚合列表</a>、为你推荐等位置，医项目卡片图</p>
 *             <img src="https://mediafiles.cn-healthcare.com/boss/popovertip/medproject_list_cover@2x.jpg" alt="" style={{ width: 600 }}/>
 *         </>}
 *     >
 *         <i className="bi bi-question-circle-fill popover-tip-icon"></i>
 *     </PopoverTip>
 * </>}
 *
 */
const PopoverTip = ({ children, title = null, trigger = 'hover', content, placement = 'top' }) => (
    <Popover title={title} trigger={trigger} content={<StyledContent>{content}</StyledContent>} placement={placement}>
        {children}
    </Popover>
);

/**
 * @typedef {Object} PopoverTipProps
 * @property {React.ReactNode} children - 触发提示的元素
 * @property {React.ReactNode} [title] - 提示框标题，默认为 null
 * @property {('hover'|'focus'|'click')} [trigger='hover'] - 触发方式，默认为 hover
 * @property {React.ReactNode} content - 提示框内容，支持 JSX
 * @property {('top'|'topLeft'|'topRight'|'bottom'|'bottomLeft'|'bottomRight'|'left'|'leftTop'|'leftBottom'|'right'|'rightTop'|'rightBottom')} [placement='top'] - 气泡框位置，默认为 top
 */

PopoverTip.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.node,
    trigger: PropTypes.oneOf(['hover', 'focus', 'click']),
    content: PropTypes.node.isRequired,
    placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight', 'left', 'leftTop', 'leftBottom', 'right', 'rightTop', 'rightBottom']),
};

export default PopoverTip;
